import {faMagnifyingGlass} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import * as styles from './auto-reply-form-popup.scss';

export const searchIcon = (
    <FontAwesomeIcon className={styles.AutoReplyFormPopup_inputIcon} icon={faMagnifyingGlass} size="sm" />
);
